import React from "react";
import { Field } from "formik";
import FormContainer from "forms/components/FormContainer";
import FormRow from "forms/components/FormRow";
import { DropdownField, MultiDropdownField } from "forms/fields";
import includes from "lodash/includes";
import PropTypes from "prop-types";
import Information from "rialto-icons/Information";

import { DropdownSubtitleItem } from "components/Dropdown";
import { Translate } from "utils";
import { LimitationsContext } from "utils/Authenticated";
import { isRequired } from "utils/validation";

import styles from "forms/forms.css";

const { t } = new Translate("DealForm");

class PortfolioAssetField extends React.Component {
  componentWillUpdate({ asset, isDisabled, portfolio }) {
    const { onSelectAsset, onSelectPortfolio } = this.props;

    if (onSelectPortfolio && !isDisabled && this.props.portfolio !== portfolio) onSelectPortfolio();
    if (onSelectAsset && asset && asset !== this.props.asset) onSelectAsset(asset.id);
  }

  render() {
    const { assets, isBroker, isDisabled, isSingleAsset, portfolio, portfolios } = this.props;
    const showAssets = portfolio && assets.length > 0;

    const valueExtractor = isBroker
      ? (p) => ({ title: p.name, subtitle: p.company.name })
      : (p) => p.name;

    return (
      <LimitationsContext.Consumer>
        {(limitations) => (
          <FormContainer title={t("portfolio.title")}>
            <FormRow>
              <Field
                component={DropdownField}
                dropdownComponent={isBroker ? DropdownSubtitleItem : undefined}
                inputValueExtractor={(p) => p.name}
                isDisabled={isDisabled}
                name="portfolio"
                placeholder={t("placeholders.portfolios")}
                validate={isRequired}
                valueExtractor={valueExtractor}
                values={portfolios}
              />
              {!includes(limitations, "assets") && showAssets && (
                <Field
                  component={isSingleAsset ? DropdownField : MultiDropdownField}
                  isDisabled={isDisabled}
                  name={isSingleAsset ? "asset" : "assets"}
                  placeholder={isSingleAsset ? t("placeholders.asset") : t("placeholders.assets")}
                  valueExtractor={(v) => v.name}
                  values={assets}
                />
              )}
            </FormRow>
            {!includes(limitations, "assets") && showAssets && !isDisabled && !isSingleAsset && (
              <FormRow columns={1}>
                <div className={styles.info}>
                  <Information />
                  {t("assets.info")}
                </div>
              </FormRow>
            )}
          </FormContainer>
        )}
      </LimitationsContext.Consumer>
    );
  }
}

PortfolioAssetField.propTypes = {
  asset: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  assets: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  onSelectPortfolio: PropTypes.func,
  onSelectAsset: PropTypes.func,
  isDisabled: PropTypes.bool,
  isSingleAsset: PropTypes.bool,
  portfolio: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
  portfolios: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  isBroker: PropTypes.bool,
};

export default PortfolioAssetField;
